import { formatMs } from "@/features/analytics/service/stats";
import { ChevronDown } from "lucide-react";

type StudentWelcomeProps = {
  name: string;
  totalTimeMs?: number;
  masteredCount?: number;
  inProgressCount?: number;
  notStartedCount?: number;
  // The three chips read differently depending on what the page is counting.
  // The schedule view counts schedule buckets and the export labels them
  // Finished / Incomplete / Pending, matching its own tab names; the lessons and
  // classrooms views count progress statuses, where Completed / In Progress /
  // Not Started is the right vocabulary. Same component, same colours, same
  // order -- only the words differ, so they are a prop rather than a fork.
  summaryLabels?: readonly [string, string, string];
  showSummary?: boolean;
};
const STATUS_COLORS = {
  MASTERED: "#96D932",
  IN_PROGRESS: "#FAD30D",
  NOT_STARTED: "#E3E3E3",
};

const StudentWelcome = ({
  name,
  totalTimeMs = 0,
  masteredCount = 0,
  inProgressCount = 0,
  notStartedCount = 0,
  summaryLabels = ["Completed", "In Progress", "Not Started"],
  showSummary = false,
}: StudentWelcomeProps) => {
  const [masteredLabel, inProgressLabel, notStartedLabel] = summaryLabels;
  return (
    <section className="et-welcome">
      <div>
        <h1>
          Hey there, <em>{name || "learner"}!</em>
        </h1>
        {showSummary && (
          <details className="et-learning-summary">
            <summary>
              Your learning so far <ChevronDown size={16} aria-hidden="true" />
            </summary>
            <p>
              Total learning time: <strong>{formatMs(totalTimeMs)}</strong>
            </p>
            <div className="et-summary-counts">
              <span>
                <i style={{ background: STATUS_COLORS.MASTERED }} />
                {masteredLabel}: {masteredCount}
              </span>
              <span>
                <i style={{ background: STATUS_COLORS.IN_PROGRESS }} />
                {inProgressLabel}: {inProgressCount}
              </span>
              <span>
                <i style={{ background: STATUS_COLORS.NOT_STARTED }} />
                {notStartedLabel}: {notStartedCount}
              </span>
            </div>
          </details>
        )}
      </div>
      <img
        src={
          showSummary
            ? "/design/learning-globe.webp"
            : "/design/classroom-conversation.webp"
        }
        alt=""
      />
    </section>
  );
};

export default StudentWelcome;
